import { InvokeCall } from "../types/InvokeCall";

export interface ReceivedMessage {
    messageType: string;
    args: unknown[];
}

export interface MessagesState {
    messages: ReceivedMessage[];
    callsToInvoke: InvokeCall[];
    pendingInvokeCall?: InvokeCall;
}

export const initialState: MessagesState = {
    messages: [],
    callsToInvoke: [],
    pendingInvokeCall: undefined,
};
